import React from 'react';
import { Link } from 'react-router-dom';
import { Logo } from './Logo';
import { useT } from '../utils/i18n';
import { CredentialsBar } from './CredentialsBar';
export function Footer() {
  const t = useT();
  return <footer className="pt-12 border-t border-white/10 transition-colors duration-300 bg-black" data-id="element-657">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 pb-12" data-id="element-658">
        <div className="grid grid-cols-1 md:grid-cols-5 gap-8 mb-8 border-b border-white/20 pb-8" data-id="element-659">
          <div className="md:col-span-2" data-id="element-660">
            <Link to="/" className="inline-block mb-4" data-id="element-661">
              <Logo imgClassName="h-10 w-auto" invertOnLight={false} cycleEvery={3} data-id="element-662" />
            </Link>
            <p className="text-sm font-medium leading-relaxed max-w-sm text-[#ffffff]" data-id="element-663">
              {t('footer.tagline')}
            </p>
          </div>

          <div data-id="element-664">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-665">
              {t('footer.contact')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-666">
              <li data-id="element-667">
                <a href="tel:206-619-3742" className="hover:text-white/70 transition-colors" data-id="element-668">
                  (206) 619-3742
                </a>
              </li>
              <li data-id="element-669">
                <a href="mailto:info@253gravel.com" className="hover:text-white/70 transition-colors" data-id="element-670">
                  info@253gravel.com
                </a>
              </li>
              <li data-id="element-671">Bonney Lake, WA</li>
            </ul>
          </div>

          <div data-id="element-672">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-673">
              {t('footer.hours')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-674">
              <li className="flex justify-between" data-id="element-675">
                <span data-id="element-676">{t('footer.monFri')}</span>
                <span data-id="element-677">6:00 AM – 5:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-678">
                <span data-id="element-679">{t('footer.saturday')}</span>
                <span data-id="element-680">7:00 AM – 3:00 PM</span>
              </li>
              <li className="flex justify-between" data-id="element-681">
                <span data-id="element-682">{t('footer.sunday')}</span>
                <span data-id="element-683">{t('footer.closed')}</span>
              </li>
            </ul>
          </div>

          <div data-id="element-684">
            <h4 className="font-heading text-[#ffffff] font-bold mb-4" data-id="element-685">
              {t('footer.resources')}
            </h4>
            <ul className="space-y-3 text-sm font-medium text-[#ffffff]" data-id="element-686">
              <li data-id="element-687">
                <Link to="/compare" className="hover:text-white/70 transition-colors" data-id="element-688">
                  {t('nav.compareMaterials')}
                </Link>
              </li>
              <li data-id="element-689">
                <Link to="/delivery-prep" className="hover:text-white/70 transition-colors" data-id="element-690">
                  {t('footer.deliveryPrep')}
                </Link>
              </li>
              <li data-id="element-691">
                <Link to="/delivery-zones" className="hover:text-white/70 transition-colors" data-id="element-692">
                  {t('nav.deliveryZones')}
                </Link>
              </li>
              <li data-id="element-693">
                <Link to="/diy-help" className="hover:text-white/70 transition-colors" data-id="element-694">
                  {t('footer.diyGuide')}
                </Link>
              </li>
              <li data-id="element-695">
                <Link to="/help" className="hover:text-white/70 transition-colors" data-id="element-696">
                  {t('footer.materialQuiz')}
                </Link>
              </li>
            </ul>
          </div>
        </div>

        <div className="flex flex-col md:flex-row justify-between items-center text-sm font-medium text-white/60" data-id="element-697">
          <p data-id="element-698">
            &copy; {new Date().getFullYear()} 253Gravel. {t('footer.rights')}
          </p>
          <div className="mt-4 md:mt-0 space-x-6" data-id="element-699">
            <a href="#" className="hover:text-white transition-colors" data-id="element-700">
              {t('footer.privacy')}
            </a>
            <a href="#" className="hover:text-white transition-colors" data-id="element-701">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
      <CredentialsBar data-id="element-702" />
    </footer>;
}